import { Component, inject } from '@angular/core';


import { PageBaseComponent } from 'src/app/@shared/components/abstract/page-base.component';
import { LoginFormComponent } from '../../components/login-form/login-form.component';
import { LegalFooterComponent } from "../../../legal/components/legal-footer/legal-footer.component";

import { ClientContextService } from 'src/app/@core/services/client/client-context.service';

@Component({
    selector: 'app-login',
    imports: [
    LoginFormComponent,
    LegalFooterComponent
],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent extends PageBaseComponent {
    private _clientContextService = inject(ClientContextService);

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    /**
     * Point de passage unique de toutes les sorties de session — déconnexion
     * explicite comme expiration — donc l'endroit où l'on oublie le dossier (#173).
     * Le retour au bon écran est assuré par le paramètre `redirect`, pas par la
     * préférence d'ouverture.
     */
    protected override loadData(): void {
        this._clientContextService.forget();
    }
}
